// Module
var code = `<nav class="navbar navbar-expand-lg navbar-light fixed-top">
	<div class="container-fluid">
		<button class="navbar-toggler" type="button" ng-click="\$ctrl.isMenuCollapsed = !\$ctrl.isMenuCollapsed"
			aria-controls="manager-menu" aria-expanded="{{!\$ctrl.isMenuCollapsed}}" aria-label="Toggle navigation">
			<i class="fas fa-bars"></i>
		</button>
		<span class="navbar-text me-2" title="{{\$ctrl.getConnectionStatusTitle()}}">
			<i class="fa {{\$ctrl.getConnectionStatusIcon()}} fs-5 connection-pulse"></i>
		</span>
		<a class="navbar-brand" title="{{\$ctrl.version | jumbotronVersion}}">JumboTRON</a>

		<div id="manager-menu" class="collapse navbar-collapse" ng-class="{'show': !\$ctrl.isMenuCollapsed}">
			<ul class="navbar-nav me-auto">
				<li class="nav-item" ui-sref-active="active">
					<a class="nav-link" ui-sref="manager.library">Library</a>
				</li>
				<li class="nav-item scene-nav-item" ng-class="{ active: \$ctrl.isActive(scene.id) }"
					ng-repeat="scene in \$ctrl.Scenes track by scene.id">
					<a class="nav-link" ui-sref="manager.scene({id:scene.id})"
						ng-style="\$ctrl.isActive(scene.id) ? { 'background-color': scene.color } : { 'color': scene.color }">
						<span title="{{scene.version | jumbotronVersionJson}}">{{scene.name}}</span>
					</a>
					<a class="nav-link scene-play-link" ng-if="\$ctrl.clientId !== scene.clientId"
						ui-sref="manager.preview({id:scene.id})">
						<i class="fa fa-play" ng-style="{'color': scene.color}"></i>
					</a>
					<!-- [html-validate-disable-next attribute-misuse -- ui-sref genererer href ved runtime] -->
					<a class="nav-link scene-play-link" ng-if="\$ctrl.clientId === scene.clientId"
						ui-sref="player({id:scene.name})" target="_blank">
						<i class="fa fa-play" ng-style="{'color': scene.color}"></i>
					</a>
				</li>
			</ul>
			<ul class="navbar-nav">
				<li class="nav-item" ng-if="\$ctrl.uploadStats.filesRemaining">
					<span class="navbar-text">
						<span>Uploading &nbsp;</span>
						<i class="fas fa-circle-notch fa-spin"></i>
					</span>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
						ng-click="\$ctrl.toggleDropdown(\$event)" aria-haspopup="true"
						aria-expanded="{{\$ctrl.isDropdownOpen}}">
						Menu
					</a>
					<ul class="dropdown-menu dropdown-menu-end" ng-class="{'show': \$ctrl.isDropdownOpen}">
						<li><a class="dropdown-item" ui-sref="manager.socialmediaapprover"><i
									class="fab fa-instagram"></i> Approver</a></li>
						<li><a class="dropdown-item" ui-sref="manager.report"><i class="fas fa-chart-simple" aria-hidden="true"></i> Report</a></li>
						<li><a class="dropdown-item" ui-sref="manager.styleguide"><i class="fas fa-swatchbook" aria-hidden="true"></i> Style guide</a></li>
						<li><a class="dropdown-item" ui-sref="manager.settings">Configure Scenes</a></li>
						<li><a class="dropdown-item" ui-sref="manager.about">About</a></li>
						<li>
							<hr class="dropdown-divider">
						</li>
						<li><span class="dropdown-header">Theme</span></li>
						<!-- The check marks the theme that the operator picked. The navbar gives every item in this menu the ink of the page. The active class of Bootstrap would put that ink on a blue ground. -->
						<li><a class="dropdown-item" href="javascript:void(0)" ng-click="\$ctrl.setTheme('system')"
								aria-current="{{\$ctrl.theme === 'system'}}"><i class="fas fa-circle-half-stroke"
									aria-hidden="true"></i> System theme <i class="fas fa-check" aria-hidden="true"
									ng-if="\$ctrl.theme === 'system'"></i></a></li>
						<li><a class="dropdown-item" href="javascript:void(0)" ng-click="\$ctrl.setTheme('light')"
								aria-current="{{\$ctrl.theme === 'light'}}"><i class="fas fa-sun"
									aria-hidden="true"></i> Light <i class="fas fa-check" aria-hidden="true"
									ng-if="\$ctrl.theme === 'light'"></i></a></li>
						<li><a class="dropdown-item" href="javascript:void(0)" ng-click="\$ctrl.setTheme('dark')"
								aria-current="{{\$ctrl.theme === 'dark'}}"><i class="fas fa-moon"
									aria-hidden="true"></i> Dark <i class="fas fa-check" aria-hidden="true"
									ng-if="\$ctrl.theme === 'dark'"></i></a></li>
						<li>
							<hr class="dropdown-divider">
						</li>
						<li><a class="dropdown-item" ui-sref="logout">Log out</a></li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</nav>
<div id="manager-content">
	<toaster-container></toaster-container>
	<alerts></alerts>
	<ui-view class="container-fluid"></ui-view>
</div>`;
// Exports
export default code;